<div>
  <kendo-grid [kendoGridBinding]="gridData" [scrollable]="'true'" [resizable]="true" [sortable]="true" [pageable]="true"
    [filter]="filters" [pageSize]="gridState.take" [skip]="gridState.skip" [sort]="gridState.sort"
    filterable="menu" id="active-task-grid">
    <!-- MOBILE VIEW -->
    <kendo-grid-column media="(max-width: 772.98px)" title="Details" [width]="150">
      <ng-template kendoGridCellTemplate let-dataItem>
        <dl>
          <dd>
            <div class="align-left">
              <span class="bold">ID#: </span>
              <span> {{ dataItem.id }}</span>
            </div>
          </dd>
          <dd>
            <div class="align-left">
              <span class="bold">Created On: </span>
              <span> {{ dataItem.createdDate | date: 'MM/dd/yyyy' }}</span>
            </div>
          </dd>
          <dd>
            <div class="align-left">
              <span class="bold">Due Date: </span>
              <span> {{ dataItem.dueDate | date: 'MM/dd/yyyy' }}</span>
            </div>
          </dd>
          <dd>
            <div class="align-left">
              <span class="bold">Task Type: </span>
              <span> {{ dataItem.taskTypeName }}</span>
            </div>
          </dd>
        </dl>
      </ng-template>
    </kendo-grid-column>
    <!-- TASK ID -->
    <kendo-grid-column media="(min-width: 773px)" field="id" title="Task ID" [width]="80"
      [headerClass]="{'align-id': true}">
      <ng-template kendoGridFilterMenuTemplate let-filter let-column="column" let-filterService="filterService">
        <kendo-grid-string-filter-menu [column]="column" [filter]="filter" [filterService]="filterService"
          [extra]="false">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-menu>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="align-id">
          <a (click)="redirectUser(dataItem)" class="clone-link">
            {{dataItem.id}}
          </a>
        </div>
      </ng-template>
    </kendo-grid-column>
    <!-- TASK CREATION DATE -->
    <kendo-grid-column media="(min-width: 773px)" field="createdDate" title="Created On" [width]="100"
      [headerClass]="{'align-date': true}">
      <ng-template kendoGridFilterMenuTemplate let-filter let-column="column" let-filterService="filterService">
        <app-date-range-filter [field]="column.field" [filter]="filter" [filterService]="filterService">
        </app-date-range-filter>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="align-date">
          {{dataItem.createdDate | date: 'MM/dd/yyyy'}}
        </div>
      </ng-template>
    </kendo-grid-column>
    <!-- TASK DUE DATE -->
    <kendo-grid-column media="(min-width: 773px)" field="dueDate" title="Due Date" [width]="100"
      [headerClass]="{'align-date': true}">
      <ng-template kendoGridFilterMenuTemplate let-filter let-column="column" let-filterService="filterService">
        <app-date-range-filter [field]="column.field" [filter]="filter" [filterService]="filterService">
        </app-date-range-filter>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="align-date">
          {{dataItem.dueDate | date: 'MM/dd/yyyy'}}
        </div>
      </ng-template>
    </kendo-grid-column>
    <!-- TASK TYPE -->
    <kendo-grid-column media="(min-width: 773px)" field="taskTypeName" title="Task Type"
      [headerStyle]="{'text-align': 'center'}" [width]="100">
      <ng-template kendoGridFilterMenuTemplate let-filter let-column="column" let-filterService="filterService">
        <kendo-grid-string-filter-menu [column]="column" [filter]="filter" [filterService]="filterService"
          [extra]="false">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-menu>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="align-center">
          <span>{{dataItem.taskTypeName}}</span>
        </div>
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>
</div>
<app-notification-loading></app-notification-loading>
